import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import _get from "lodash/get";
import _findIndex from 'lodash/findIndex';
import {getLangCode, stringBundle} from '../../stringBundle';
import utils from '../../helpers/utils';

/*eslint-disable no-unused-vars*/

/*eslint-disable react/jsx-no-bind*/

class EditTransactionPrefsForm extends Component {

  constructor(props) {
    super(props);
    const {error, initialize, handleSubmit, pristine, submitting, onSubmit} = props;
    let prefill = {};
    this.preloadData(this.props.propAlertPref);
    this.localizedStringBundle = stringBundle(getLangCode());
  }

  componentDidMount() {
    this.props.initialize(this.prefill);
    window.parent.postMessage({type: "RESIZED", payload: document.body.scrollHeight}, window.REACT_APP_PARENT_HOST);
  }
  
  componentDidUpdate() {
    window.parent.postMessage({type: "RESIZED", payload: document.body.scrollHeight}, window.REACT_APP_PARENT_HOST);
  }


  preloadData(inputData) {
    const pIndex = _findIndex(inputData, {type: 'PURCHASE'});
    const tIndex = _findIndex(inputData, {type: 'TRANSFER'});
    const wIndex = _findIndex(inputData, {type: 'WITHDRAWAL'});
    let prefs = {
      transaction: _get(inputData[pIndex], 'value', ''),
      transfer: _get(inputData[tIndex], 'value', ''),
      withdrawal: _get(inputData[wIndex], 'value', '')
    }
    this.prefill = Object.assign({}, prefs);
  }

  handleChange(item) {
    utils.trackEventForManageAccount(item, this.localizedStringBundle.MANAGE_ACCOUNT_EDIT, true);
  }

  renderDropDown(fieldName,fieldHeading,eventName) {
    return (
      <div className="flex py-8">
        <div className="flex w-1/6 py-4 font-normal text-black-dark">{fieldHeading}</div>
        <div className="flex w-5/6 input-field h-12 pl-16">
          <Field name={fieldName} component="select" className="w-5/6" onChange={this.handleChange.bind(this, eventName)}>
            <option value="100">Over $100</option>
            <option value="200">Over $200</option>
            <option value="500">Over $500</option>
            <option value="1000">Over $1,000</option>
            <option value="2000">Over $2,000</option>
            <option value="5000">Over $5,000</option>
            <option value="10000">Over $10,000</option>
            <option value="25000">Over $25,000</option>
          </Field>
        </div>
      </div>
    );
  }
  render() {
    return (
        <form method="post" onSubmit={this.props.handleSubmit(this.props.onSubmit)} className="contact-form">
          <div className="font-semibold text-black-dark text-xl">{this.localizedStringBundle.MANAGE_AP_TXM_TITLE}</div>
          <div className="pt-3 text-grey">{this.localizedStringBundle.MANAGE_AP_TXM_HEADER}</div>
          {this.renderDropDown('withdrawal',this.localizedStringBundle.MANAGE_AP_TXM_WITHDRAWAL,'TXM_Cash')}
          {this.renderDropDown('transaction',this.localizedStringBundle.MANAGE_AP_TXM_TRANSACTION,'TXM_Purchase')}
          {this.renderDropDown('transfer',this.localizedStringBundle.MANAGE_AP_TXM_TRANSFER,'TXM_Transfer')}
          <div className="flex">
            <div className="w-full text-right">
              <button id="btn-trans" className="btn mt-6 text-blue-bright  px-6 py-3 border-solid border-1 border-blue-bright" type="submit"
                      disabled={this.props.pristine || this.props.submitting} style={{display: this.props.pristine ? 'none' : 'inline-block'}}>{this.localizedStringBundle.SAVE}
              </button>
            </div>
          </div>
        </form>
    )
  }

}

EditTransactionPrefsForm.propTypes = {
  error: PropTypes.object,
  initialize: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  propAlertPref:PropTypes.object,
};

export default reduxForm({
  form: 'edittransactionpref'
})(EditTransactionPrefsForm)

/*eslint-enable no-unused-vars*/
/*eslint-enable react/jsx-no-bind*/



// WEBPACK FOOTER //
// ./src/containers/monitoring/EditTransactionPrefsForm.js